import { DeliveryInvoiceBatchDetails, DeliveryInvoiceSkuDetails, ReturnDetailsObject } from "../../types/types";
import { CollectionsState } from "../reducers/collectionReducer";
import store from "../store";

export const setReturnInvoiceDetails = (returnInvoiceDetails: any[]) => {
  store.dispatch({
    type: "setReturnInvoiceDetails",
    payload: returnInvoiceDetails,
  });
};

export const setCollectionSelectedRowToEdit = (row: any | null) => {
  store.dispatch({
    type: "setCollectionSelectedRowToEdit",
    payload: row,
  });
};

export const setCollectionDisableEditing = (disable: boolean) => {
  store.dispatch({
    type: "setCollectionDisableEditing",
    payload: disable,
  });
};

export const setDeliveryStatus = (status: string) => {
  store.dispatch({
    type: "setDeliveryStatus",
    payload: status,
  });
};

export const setAllReturnedCombinedData = (allReturnedCombinedData: DeliveryInvoiceSkuDetails[]) => {
  store.dispatch({
    type: "setAllReturnedCombinedData",
    payload: allReturnedCombinedData,
  });
};

export const setReturnDetails = (data :ReturnDetailsObject)=>{
  store.dispatch({
    type: "setReturnDetails",
    payload: data
  });
}

export const setBatchDetails = (data :{[key:string]:{[key:string]:DeliveryInvoiceBatchDetails[]}})=>{
  store.dispatch({
    type: "setBatchDetails",
    payload: data
  });
}

export const setUpdatedInvoiceDetails = (data :any)=>{
  store.dispatch({
    type: "setUpdatedInvoiceDetails",
    payload: data
  });
}



export const setCollectionData = (collectionData: CollectionsState)=>{
  store.dispatch({
    type: "setCollectionData",
    payload: collectionData
  });
}

export const reInitialiseCollectionData = ()=>{
  store.dispatch({
    type: "reInitialiseData",
    payload: null
  });
}